import {DrawerRecommendation_SportsSection} from '@aboutyou/grpc-clients/tadarida/aysa_api/services/navigation/v1/recommendations.types';
import {
  COLORS,
  Heading20,
  Image,
  Text,
  UnstyledLink,
} from '@aboutyou/ui-components';
import React from 'react';
import styled from 'styled-components';

interface NavigationSportsProps {
  sports: DrawerRecommendation_SportsSection;
}

const breakpoints = [{columns: 16}];
const widths = [28, 56, 112];

export const NavigationSports = ({sports}: NavigationSportsProps) => {
  return (
    <Container data-testid="sportContainer">
      <Headline>{sports.headline}</Headline>
      <SportTiles>
        {sports.sportCategories.map(sport => {
          return (
            <SportTile key={sport.category.id}>
              <SportLink to={sport.category.path} aria-label={undefined}>
                <SportIcon
                  disableFixedRatio
                  alt={sport.icon.description}
                  breakpoints={breakpoints}
                  ratio="1:1"
                  src={sport.icon.url}
                  widths={widths}
                />

                <SportName size="px16" weight="bold">
                  {sport.category.name}
                </SportName>
              </SportLink>
            </SportTile>
          );
        })}
      </SportTiles>
    </Container>
  );
};

const Container = styled.section`
  padding: 20px 0;
`;

const Headline = styled(Heading20)`
  font-weight: 900;
  padding: 4px 0;
  margin-bottom: 30px;
  text-align: center;
`;

const SportTiles = styled.menu`
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-gap: 4px;
  padding: 0;
`;

const SportTile = styled.li`
  display: block;
  background-color: ${COLORS.Grey4};
  overflow: hidden;
`;

const SportLink = styled(UnstyledLink)`
  align-items: center;
  box-sizing: border-box;
  display: flex;
  justify-content: space-around;
  height: 60px;
  gap: 12px;
  padding: 16px;
  position: relative;
`;

const SportIcon = styled(Image)`
  object-fit: contain;
  width: 28px;
`;

const SportName = styled(Text)`
  flex: 3;
  overflow: hidden;
  text-overflow: ellipsis;
  line-height: 2;
`;
